// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__1Odzd","tabItems":"Tabs_tabItems__3Y5M7","tab":"Tabs_tab__3sXEj","active":"Tabs_active__3Zn2e","tabView":"Tabs_tabView__1g4r-"};